import { Pipe, PipeTransform } from '@angular/core';
import { Jobsite } from '@ordersnproducts/modules/orders-and-product-catalog/models';

@Pipe({
  name: 'filterJobsites',
})
export class FilterJobsitesPipe implements PipeTransform {
  transform(jobsites: Jobsite[], filter: string): Jobsite[] {
    if (!jobsites || jobsites.length === 0) {
      return [];
    }
    if (!filter || filter.length === 0) {
      return jobsites;
    }
    return jobsites.filter(
      jobsite =>
        jobsite.code.toLocaleLowerCase().search(filter.toLocaleLowerCase()) !== -1 ||
        jobsite.name.toLocaleLowerCase().search(filter.toLocaleLowerCase()) !== -1,
    );
  }
}
